import React from "react";
import { marqueeItems } from "../data/product";
export function Marquee() {
  const row = [...marqueeItems, ...marqueeItems];
  return <div className="overflow-hidden bg-[#B36C64] py-2.5" aria-label={marqueeItems.join(", ")} data-id="element-140" data-mp="2nh5t1z8opx0z">
      <div className="animate-marquee flex w-max" aria-hidden="true" data-id="element-141" data-mp="2ik70vm8l005f">
        {row.map((item, i) => <span key={i} className="flex items-center whitespace-nowrap font-serif text-sm font-semibold uppercase tracking-[0.08em] text-cream sm:text-[15px]" data-id="element-142" data-mp="2dmdzd6i83ubh" data-mpi={i}>
            <span className="px-5" data-id="element-143" data-mp="369rqup35jxo7">{item}</span>
            <span className="text-cream/70" data-id="element-144" data-mp="319vlomipy072">✦</span>
          </span>)}
      </div>
    </div>;
}